class ConfirmRegistrationController {
  constructor($stateParams, Account) {
    "ngInject";

    let vm = this;
    vm.name = 'confirmRegistration';
    vm.message = '';
    vm.init = init;
    vm.init();

    function init () {
      Account.confirmRegistration($stateParams.key)
      .then(function () {
        vm.message = "Registrazione avvenuta con successo.";
      })
      .catch(function () {
        vm.message ="Questo link non è valido oppure è già stato utilizzato";
      })
    }


  }
}

export default ConfirmRegistrationController;



// WEBPACK FOOTER //
// ./client/app/components/confirmRegistration/confirmRegistration.controller.js